import { Component } from '@angular/core'

@Component({
	selector: 'clock-cancel-icon',
	template: `
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			viewBox="0 0 24 24"
			stroke-width="2"
			stroke="currentColor"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M20.997 12.25a9 9 0 1 0 -8.718 8.745" />
			<path d="M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
			<path d="M17 21l4 -4" />
			<path d="M12 7v5l2 2" />
		</svg>
	`,
    styleUrl: './icons.component.scss',
	standalone: true,
})
export class ClockCancelIconComponent {}
